<template>
    <CModal :title="dialogTitle" :show.sync="dialogVisible">
        <CForm slot="default">
            <CInput
                v-model="model.title"
                :horizontal="true"
                label="Название"
                placeholder="Название варианта"
            />
            <CInput
                v-model="model.price"
                :horizontal="true"
                label="Цена"
                placeholder="Цена варианта"
            />
        </CForm>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>
            <CButton
                color="primary"
                class="ml-3"
                @click="submit">{{
                    submitButtonTitle
                }}</CButton>
        </div>
    </CModal>
</template>

<script>
    export default {
        name: 'AssistantOptionUpsertDialog',

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            dialogVisible: false,
            model: {},
        }),

        computed: {
            dialogTitle() {
                return typeof this.entity.id === 'number'
                    ? 'Редатирование варианта'
                    : 'Создание варианта';
            },

            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
        },

        watch: {
            dialogVisible: function (v) {
                if (v) {
                    this.setModel(this.entity);
                }
            },
        },

        methods: {
            open() {
                this.dialogVisible = true;
            },

            close() {
                this.dialogVisible = false;
            },

            setModel(source) {
                this.model = source;
            },

            async submit() {
                if (!this.model.title) {
                    this.$root.$emit('showError', 'Название варианта не может быть пустым.');
                    return;
                }
                const price = parseInt(this.model.price);
                if(isNaN(price) || price < 0) {
                    this.$root.$emit('showError', 'Цена должна быть неотрицательным целым числом.');
                    return;
                }
                this.model.price = price;

                try {
                    const { id, ...payload } = this.model;

                    if (typeof id === 'number') {
                        await this.axios.put(
                            `/assistants/${payload.assistant_id}/options/${id}`,
                            payload
                        );
                    } else {
                        await this.axios.post(
                            `/assistants/${payload.assistant_id}/options`,
                            payload
                        );
                    }

                    this.$emit('success');
                    this.close();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка создания/редактирования варианта. ' + err);
                }
            },
        },
    };
</script>
